import { render, staticRenderFns } from "./welcomeType.vue?vue&type=template&id=3ef589a0&"
import script from "./welcomeType.vue?vue&type=script&lang=js&"
export * from "./welcomeType.vue?vue&type=script&lang=js&"
import style0 from "./welcomeType.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports